<template>
  <div class="data-manage">
    <star-condition-layout
            :onSearch="getTableList"
            :onReset="reset"
            :loading="loading"
            ref="condition"
    >
      <star-condition-cell label="菜单名称">
        <a-input v-model="search.menuName" placeholder="请输入关键字"/>      </star-condition-cell>
      <star-condition-cell label="菜单状态">
        <a-select
                v-model="search.status"
                style="width: 100%"
                placeholder="请选择菜单状态"
                @change="handleSearch"
        >
          <a-select-option :value="-1"> 停用 </a-select-option>
          <a-select-option :value="1"> 启用 </a-select-option>
        </a-select>      </star-condition-cell>
    </star-condition-layout>
    <div class="table-wrap">
      <TableHeadIcons :onRefresh="getTableList" :size.sync="tableDensity" :columns="columns">
        <a-button type="primary" icon="plus" @click="handleAdd">新增</a-button>
      </TableHeadIcons>
      <a-table
        :loading="loading"
        :pagination="pagination"
        :size="tableDensity"
        rowKey="menuId"
        :columns="showColumns"
        :dataSource="dataSource"
      >
        <span slot="type" slot-scope="text, record">{{
          record.type == 'dir' ? '目录' : record.type == 'menu' ? '菜单' : '按钮 '
        }}</span>
        <span slot="status" slot-scope="text, record">{{
          record.status == '-1' ? '停用' : '启用 '
        }}</span>

        <span slot="isHide" slot-scope="text, record">{{
          record.isHide == '1' ? '隐藏' : '启用 '
        }}</span>
        <div slot="action" slot-scope="text, record">
          <a-popconfirm title="确定要删除吗?" @confirm="() => handleDelete(record)">
            <a href="javascript:;"> <a-icon type="delete" />删除 </a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a href="javascript:;" @click="handleEdit(record)"> <a-icon type="edit" /> 修改 </a>
        </div>
      </a-table>
    </div>
    <a-drawer
      :title="formModel == null ? '新增菜单' : '修改菜单'"
      width="600"
      :closable="true"
      :visible="visible"
      @close="visible = false"
    >
      <Form
        ref="form"
        v-if="visible"
        @refresh="handleRefresh"
        :formModel="formModel"
        :treeList="dataSource"
      />
    </a-drawer>
  </div>
</template>

<script>
  import { queryMenuApi, deleteMenuApi } from '@/api/System/Menu'
import Form from './Form.vue'
import { menuList2Tree } from '@/utils/'
export default {
  data() {
    return {
      loading: false,
      visible: false,
      search: {
        menuName: '',
        status: undefined
      },
      tableDensity: 'middle',
      columns: [
        {
          title: '菜单名称',
          ellipsis: true,
          show: true,
          dataIndex: 'menuName',
          width: 150
        },
        {
          title: '菜单路径',
          ellipsis: true,
          show: true,
          dataIndex: 'path',
          width: 160
        },
        {
          title: '组件路径',
          ellipsis: true,
          show: true,
          dataIndex: 'componentPath'
        },
        {
          title: '类型',
          show: true,
          scopedSlots: { customRender: 'type' },
          width: 80
        },
        {
          title: '状态',
          show: true,
          scopedSlots: { customRender: 'status' },
          width: 80
        },
        {
          title: '是否隐藏',
          ellipsis: true,
          show: true,
          scopedSlots: { customRender: 'isHide' },
          width: 90
        },
        {
          title: '排序',
          show: true,
          dataIndex: 'orderNum',
          width: 60
        },
        {
          title: '图标',
          ellipsis: true,
          show: true,
          dataIndex: 'icon',
          width: 100
        },
        {
          title: '操作',
          width: 150,
          show: true,
          scopedSlots: { customRender: 'action' }
        }
      ],
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },
      sorter: {},
      formModel: null
    }
  },
  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },
  created() {
    this.getTableList()
  },
  methods: {
    reset() {
      this.search.menuName = undefined
      this.search.status = undefined
      this.getTableList()
    },
    handleSearch() {
      this.pagination.current = 1
      this.getTableList()
    },

    handleReset() {
      this.search.status = undefined
      this.search.menuName = ''
      this.handleSearch()
    },

    //根据id删除数据
    async handleDelete(record) {
      const res = await deleteMenuApi({ ...record })
      const { code, msg } = res
      if (code == '200') {
        this.getTableList()
        this.$message.success(msg)
      } else {
        this.$message.error(msg)
      }
    },

    handleAdd() {
      this.visible = true
      this.formModel = null
    },

    handleEdit(record) {
      this.visible = true
      this.formModel = record
    },

    handleRefresh() {
      this.visible = false
      this.getTableList()
    },

    async getTableList() {
      let query = {
        ...this.search
      }
      this.loading = true
      let res = await queryMenuApi(query)
      this.loading = false
      let { code, msg, data } = res
      if (code == '200') {
        this.dataSource = menuList2Tree(data)
      } else {
        this.$message.error(msg)
      }
    }
  },
  components: {
    Form
  }
}
</script>

<style lang="less" scoped>
.data-manage {
  padding: 16px;
  .search {
    padding: 20px 20px 0 20px;
    background: #fff;
    margin-bottom: 20px;
  }
  .table-wrap {
    background: #fff;
    padding: 0 20px 0 20px;
    margin-top: 16px;
  }
}
</style>
